(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name thismomentGlowModulePlaylist
   * @module thismoment.glow.component.module.multi-playlist
   *
   * @description
   * Embeds a configurable playlist into a Glow page.
   */

  require('./scss/module-multi-playlist.scss')

  const MODULE_NAME = 'thismoment.glow.component.module.multi-playlist'
  const templateUrl = require('./tpl/module-multi-playlist.html')

  angular
    .module(MODULE_NAME, [
      require('../../../../playlist')
    ])
    .component('thismomentGlowModuleMultiPlaylist', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        cardOptions: '<',
        cardSharing: '<',
        displayCart: '<',
        forceSingleColumn: '<',
        layout: '<',
        layoutOptions: '<',
        loaderColor: '<',
        maxColumnCount: '<',
        paginatorLimit: '<',
        playlists: '<',
        playlistOrder: '<',
        playlistSearch: '<'
      },
      controller: glowMultiPlaylistController
    })

  glowMultiPlaylistController.$inject = ['$location', '$timeout', '$scope', '$state', 'SdkConfig', 'GlowConfig', 'PlaylistContent', 'Content', 'ExpandedContent']
  function glowMultiPlaylistController ($location, $timeout, $scope, $state, SdkConfig, GlowConfig, PlaylistContent, Content, ExpandedContent) {
    const vm = this

    vm.$onInit = PlaylistInit
    function PlaylistInit () {
      // display options
      vm.cardOptions.card_cart_display = vm.displayCart

      // used to destroy and recreate the playlist on navigation
      vm.displayPlaylist = false
      vm.selectPlaylist = selectPlaylist

      // init the first playlist
      selectPlaylist(vm.playlists[0].playlist_id)
      vm.playlistIds = vm.playlists.map((playlist) => playlist.playlist_id)

      // listen for breakpoint changes
      evaluateBreakpoint()
      $scope.$on('breakpoint:resize', function () {
        evaluateBreakpoint()
        $scope.$apply()
      })

      // deeplink logic
      var params = $location.search()
      if ('playlistId' in params && vm.playlistIds.includes(parseInt(params.playlistId)) && 'contentId' in params) {
        PlaylistContent
          .get(
            {
              playlist_id: params.playlistId,
              content_id: params.contentId
            },
            function (response) {
              if (angular.isArray(response.data.content) && response.data.content.length > 0) {
                Content.addContent('deeplink', response.data.content[0])
                ExpandedContent.open(response.data.content[0], { displayShare: true, playlistId: params.playlistId })
              } else {
                $state.go('glow.page')
              }
            }
          )
      }
    }

    function selectPlaylist (playlistId) {
      vm.displayPlaylist = false
      vm.playlistId = playlistId
      $timeout(() => {
        vm.loadItems = createLoadItems()
        vm.displayPlaylist = true
      })
    }

    function createLoadItems () {
      return (limit, offset, search, order, randomContent, success, error) => {
        const params = {
          limit: limit,
          offset: offset,
          search_query: search,
          order: order,
          random_content: randomContent,
          meta: false
        }
        if (typeof search === 'string' && search.length > 0) {
          params.playlist_ids = vm.playlistIds.join(',')
        } else {
          params.playlist_id = vm.playlistId
        }
        return PlaylistContent.get(
          params,
          (response) => {
            const items = response.data.content
            angular.forEach(items, (item) => {
              if (['html', 'vcard-dynamic', 'vcard-image-promo'].includes(item.type_name)) {
                if (GlowConfig.get('vcard')) {
                  item.app.vcard = true
                }
                item.app.user = {
                  vcard: GlowConfig.get('vcard')
                }
              }
            })
            if (typeof success === 'function') success(items)
            return items
          }, error)
      }
    }

    function evaluateBreakpoint () {
      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
          vm.isNavCollapsed = true
          break

        case 'sm':
        case 'md':
        case 'lg':
          vm.isNavCollapsed = false
          break
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-multi-playlist/index.js